var $cbf94d6a2724aeeb$exports = {};
const $cbf94d6a2724aeeb$var$BREAKPOINT = 600;
const $cbf94d6a2724aeeb$var$PER_PAGE_DESKTOP = 3;
const $cbf94d6a2724aeeb$var$PER_PAGE_MOBILE = 1;
function $cbf94d6a2724aeeb$var$initSlider(section) {
    const viewport = section.querySelector('.reviews-summary__viewport');
    const list = section.querySelector('.reviews-summary__list');
    const items = Array.from(section.querySelectorAll('.reviews-summary__item'));
    const prevBtn = section.querySelector('.reviews-summary__nav--prev');
    const nextBtn = section.querySelector('.reviews-summary__nav--next');
    const dotsContainer = section.querySelector('.reviews-summary__dots');
    if (!viewport || !list || items.length === 0) return;
    let currentPage = 0;
    function getPerPage() {
        return window.innerWidth >= $cbf94d6a2724aeeb$var$BREAKPOINT ? $cbf94d6a2724aeeb$var$PER_PAGE_DESKTOP : $cbf94d6a2724aeeb$var$PER_PAGE_MOBILE;
    }
    function getTotalPages() {
        return Math.ceil(items.length / getPerPage());
    }
    function updateItemWidths() {
        const w = viewport.offsetWidth / getPerPage();
        items.forEach((item)=>{
            item.style.width = `${w}px`;
        });
    }
    function updateTransform() {
        list.style.transform = `translateX(${-currentPage * viewport.offsetWidth}px)`;
    }
    function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        const total = getTotalPages();
        if (total <= 1) {
            dotsContainer.hidden = true;
            return;
        }
        dotsContainer.hidden = false;
        for(let i = 0; i < total; i++){
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `reviews-summary__dot${i === currentPage ? ' is-active' : ''}`;
            dot.setAttribute('aria-label', `Vai alla pagina ${i + 1}`);
            dot.addEventListener('click', ()=>goTo(i));
            dotsContainer.appendChild(dot);
        }
    }
    function updateDots() {
        if (!dotsContainer) return;
        dotsContainer.querySelectorAll('.reviews-summary__dot').forEach((dot, i)=>{
            dot.classList.toggle('is-active', i === currentPage);
        });
    }
    function updateNav() {
        const total = getTotalPages();
        const hide = total <= 1;
        if (prevBtn) {
            prevBtn.hidden = hide;
            prevBtn.disabled = currentPage <= 0;
        }
        if (nextBtn) {
            nextBtn.hidden = hide;
            nextBtn.disabled = currentPage >= total - 1;
        }
    }
    function goTo(page) {
        currentPage = Math.max(0, Math.min(page, getTotalPages() - 1));
        updateTransform();
        updateDots();
        updateNav();
    }
    prevBtn?.addEventListener('click', ()=>goTo(currentPage - 1));
    nextBtn?.addEventListener('click', ()=>goTo(currentPage + 1));
    updateItemWidths();
    buildDots();
    updateNav();
    let raf;
    window.addEventListener('resize', ()=>{
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(()=>{
            currentPage = 0;
            updateItemWidths();
            buildDots();
            updateNav();
            updateTransform();
        });
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('[data-reviews-slider]').forEach((section)=>$cbf94d6a2724aeeb$var$initSlider(section));
});


//# sourceMappingURL=cv-builder.f6a6b0f8.js.map
